import { defaultClient } from '@api/client';

export const regenerateAccessToken = ({ id }) => {
  return defaultClient.get(`/admin/users/${id}/accessToken`);
};
